"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeUrl = exports.setInternalAppSessionId = exports.getSourceValue = exports.getReferrer = exports.getQueryParams = void 0;
var firefly_utilities_helper_ts_1 = require("firefly-utilities-helper-ts");
var firefly_utilities_ts_1 = require("firefly-utilities-ts");
var firefly_shared_ts_1 = require("firefly-shared-ts");
function assignQueryParams(queryParamsDict, queryStringParts) {
    var part;
    for (var i = 0; i < queryStringParts.length; i += 1) {
        part = queryStringParts[i].split("=");
        if (part.length === 2) {
            queryParamsDict[part[0].toLowerCase()] = part[1];
        }
    }
}
function setParam(url, key, val) {
    return url.replace(new RegExp("&" + key + "=" + val), "");
}
function stripQueryParams(url) {
    if ((0, firefly_utilities_helper_ts_1.isString)(url) && url.indexOf('?') !== -1) {
        url = url.split('?')[0];
    }
    return url;
}
function getQueryParams(url) {
    var queryParams, queryStringParts, queryParamsDict;
    queryParamsDict = {};
    if (url.indexOf("?") > -1) {
        queryParams = url.split("?")[1];
        if (queryParams.indexOf("#") > -1) {
            queryStringParts = queryParams.split("#");
            assignQueryParams(queryParamsDict, queryStringParts);
            queryStringParts = queryStringParts[1].split("&");
        }
        if (queryStringParts === undefined) {
            queryStringParts = queryParams.split("&");
        }
        assignQueryParams(queryParamsDict, queryStringParts);
    }
    else if (url.indexOf("#") > -1) {
        queryParams = url.split("#")[1];
        queryStringParts = queryParams.split("&");
        assignQueryParams(queryParamsDict, queryStringParts);
    }
    return queryParamsDict;
}
exports.getQueryParams = getQueryParams;
function getReferrer(persistMethod) {
    var referrer = "";
    var prevPageUrl = firefly_utilities_ts_1.FFPersistenceManager.getSessionValue('prevPageUrl', persistMethod);
    var currentReferrer = stripQueryParams(document.referrer);
    var currentUrl = stripQueryParams(firefly_shared_ts_1.Browser.getCurrentUrl());
    prevPageUrl = ((0, firefly_utilities_helper_ts_1.isNullOrUndefined)(prevPageUrl)) ? "" : prevPageUrl;
    if (!(0, firefly_utilities_helper_ts_1.isEmptyString)(currentReferrer)) {
        referrer = currentReferrer;
        if (!(0, firefly_utilities_helper_ts_1.isEmptyString)(prevPageUrl) && prevPageUrl !== currentUrl) {
            referrer = prevPageUrl;
        }
    }
    else if (!(0, firefly_utilities_helper_ts_1.isEmptyString)(prevPageUrl)) {
        referrer = prevPageUrl;
    }
    firefly_utilities_ts_1.FFPersistenceManager.setSessionValue('prevPageUrl', currentUrl, persistMethod);
    return referrer;
}
exports.getReferrer = getReferrer;
function getSourceValue() {
    var sourceValue;
    var ipad = /iPad/i;
    var mobile = /Android|BlackBerry|IEMobile|iPhone|iPod|Opera Mini|NokiaBrowser|Silk|webOs|Windows Phone/i;
    var nonDesktop = /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|NokiaBrowser|Silk|mobile|tablet/i;
    var userAgent = firefly_shared_ts_1.Browser.getName();
    switch (true) {
        case !nonDesktop.test(userAgent):
            sourceValue = 1;
            break;
        case mobile.test(userAgent):
            sourceValue = 2;
            break;
        case ipad.test(userAgent):
            sourceValue = 3;
            break;
        default:
            sourceValue = 0;
            break;
    }
    return sourceValue;
}
exports.getSourceValue = getSourceValue;
function setInternalAppSessionId() {
    var sessionId = firefly_utilities_ts_1.FFPersistenceManager.getSessionStorageValue('sessionId');
    if ((0, firefly_utilities_helper_ts_1.isNullOrUndefined)(sessionId)) {
        sessionId = firefly_shared_ts_1.Identity.createSessionId();
        firefly_utilities_ts_1.FFPersistenceManager.setSessionStorageValue('sessionId', sessionId);
    }
    return sessionId;
}
exports.setInternalAppSessionId = setInternalAppSessionId;
function sanitizeUrl(url) {
    if ((0, firefly_utilities_helper_ts_1.isString)(url)) {
        var queryParams = getQueryParams(url);
        for (var key in queryParams) {
            var lowerCaseKey = key.toLowerCase();
            if (lowerCaseKey === 'pass' || lowerCaseKey === 'password' || lowerCaseKey === 'pwd' || lowerCaseKey === 'passwd') {
                url = setParam(url, key, queryParams[key]);
            }
        }
    }
    return url;
}
exports.sanitizeUrl = sanitizeUrl;
